import { Box } from "@chakra-ui/react";
import { FC, ReactNode } from "react";

import gridStyles from "../styles/Grid.module.css";

export interface HeaderBarProps {
  color: string;
  backgroundColor: string;
  children: ReactNode;
}

const HeaderBar: FC<HeaderBarProps> = ({ children, color, backgroundColor }) => {
  return (
    <Box
      backgroundColor={backgroundColor}
      color={color}
      textTransform="uppercase"
      lineHeight="24px"
    >
      <div className={gridStyles.Container}>
        <div className={gridStyles.Row}>{children}</div>
      </div>
    </Box>
  );
};

export default HeaderBar;
